import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = hash.match(/session_id=([^&]+)/)?.[1];
    if (!sessionId) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/emergent-session", { session_id: sessionId });
        setUser(data.user);
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { state: { user: data.user } });
      } catch (err) {
        console.error("Google sign-in failed", err);
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center">
      <div className="text-[color:var(--text-muted)]">Completing sign in…</div>
    </div>
  );
}
